define("analytics-resources/services/highcharts-library", ["exports", "@ember/debug", "@ember/service", "@glimmer/tracking", "highcharts", "highcharts/modules/map", "highcharts/modules/wordcloud"], function (_exports, _debug, _service, _tracking, Highcharts, _map, _wordcloud) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/service",0,"@glimmer/tracking",0,"highcharts",0,"highcharts/modules/map",0,"highcharts/modules/wordcloud"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let HighchartsLibraryService = _exports.default = (_dec = (0, _service.service)('user-config'), (_class = class HighchartsLibraryService extends _service.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _initializerDefineProperty(this, "isHighchartsSetup", _descriptor2, this);
    }
    get userTimeZone() {
      return this.userConfig.currentTimeZone.identifier;
    }

    /**
     * Proxy call to the Highcharts `chart` method which
     * generates a new Chart instance. Serves as a way to avoid
     * interacting with Highcharts directly from anywhere
     * outside of this service.
     * https://api.highcharts.com/class-reference/Highcharts.Chart
     */
    async chart(id, chartOptions, callback) {
      if (!this.isHighchartsSetup) {
        await this._setupHighcharts();
      }
      (false && !(document.getElementById(id)) && (0, _debug.assert)('You must provide a valid chart id', document.getElementById(id)));
      return Highcharts.chart(id, chartOptions, callback);
    }
    _setupHighcharts() {
      Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        time: {
          timezone: this.userTimeZone
        }
      });
      (0, _wordcloud.default)(Highcharts);
      (0, _map.default)(Highcharts);
      this.isHighchartsSetup = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isHighchartsSetup", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class));
});